import { objectToCamel } from 'ts-case-convert';

import { BillingSettingsResponseParams } from '../@types';

export type BillingDataType = Record<string, any>;

export const BillingDefault: BillingDataType[] = [
  {
    id: 'email',
    label: 'Billing E-mail',
    name: 'billingEmail',
    isRequired: false,
  },
  {
    id: 'address1',
    label: 'Billing Address',
    name: 'billingAddress1',
    isRequired: false,
  },
  {
    id: 'address2',
    label: 'Billing Address 2',
    name: 'billingAddress2',
    isRequired: false,
  },
  {
    id: 'city',
    label: 'Billing City',
    name: 'billingCity',
    isRequired: false,
  },
  {
    id: 'zip',
    label: 'Billing Zip',
    name: 'billingZip',
    isRequired: false,
  },
  {
    id: 'state',
    label: 'Billing State',
    name: 'billingState',
    isRequired: false,
  },
  {
    id: 'country',
    label: 'Billing Country',
    name: 'billingCountry',
    isRequired: false,
    options: [
      { name: 'United States', value: 'US' },
      { name: 'Canada', value: 'CA' },
      { name: 'Mexico', value: 'MX' },
      { name: 'Brazil', value: 'BR' },
    ],
  },
];

const DisplaySuffix = '_billing_address_display';
const MandatorySuffix = '_billing_address_mandatory';

export const parseBillingAddressFields = (data: BillingDataType): BillingDataType[] => {
  const keys = Object.keys(data);
  return BillingDefault
    .filter((el: BillingDataType) => keys.includes(`${el.id}${DisplaySuffix}`))
    .map((el: BillingDataType) => ({
      ...el,
      isRequired: keys.includes(`${el.id}${MandatorySuffix}`),
    }));
};

export const billingConfigApiToObject = (data: BillingSettingsResponseParams): BillingDataType => {
  const basicBillingFields = objectToCamel(
    Object.fromEntries(
      Object.keys(data)
        .filter(el => el !== 'document') // BE sends improper config
        .map((el: string) => ([
          `billing_${el}`,
          { required: data[el as keyof BillingSettingsResponseParams] === 'mandatory' },
        ])),
    ),
  );

  // fixing improper config from BE
  const documentFields = data.document ? {
    billingDocumentType: { required: data.document === 'mandatory' },
    billingDocumentNumber: { required: data.document === 'mandatory' },
  } : {};

  return {
    ...documentFields,
    ...basicBillingFields,
  };
};
